/**
 * Centralized URL Configuration
 * All URLs are sourced from environment variables
 * This prevents hardcoding URLs throughout the application
 */

const getFrontendUrl = () => {
  if (process.env.REACT_APP_FRONTEND_URL) {
    return process.env.REACT_APP_FRONTEND_URL;
  }
  
  if (process.env.NODE_ENV === "production") {
    return "https://staging.booktrivana.com";
  }
  
  return "http://localhost:3000";
};

const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  if (process.env.NODE_ENV === "production") {
    return "https://apistaging.booktrivana.com/api";
  }
  
  return "https://staging.booktrivana.com/api";
};

const FRONTEND_URL = getFrontendUrl();
const API_URL = getApiUrl();

/**
 * Export all application URLs
 * Use these constants throughout your app instead of hardcoding URLs
 */
export const APP_URLS = {
  // Frontend URLs
  FRONTEND: FRONTEND_URL,
  REFER: `${FRONTEND_URL}/refer`,
  BOOKING_VERIFY_QR: `${FRONTEND_URL}/booking/verifybyqr`,
  
  // API URLs
  API: API_URL,
  AUTH: `${API_URL}/auth`,
  BOOKINGS: `${API_URL}/bookings`,
  HOTELS: `${API_URL}/hotels`,
  RESTAURANTS: `${API_URL}/restaurants`,
  PROFILE: `${API_URL}/profile`,
  BLOG: `${API_URL}/blog`,
  
  // Social sharing endpoints (these remain hardcoded for social networks)
  SOCIAL: {
    FACEBOOK: "https://www.facebook.com/sharer/sharer.php",
    TWITTER: "https://twitter.com/intent/tweet",
    WHATSAPP: "whatsapp://send",
    EMAIL: "mailto:",
  }
};

// SEO URLs
export const SEO_URLS = {
  OG_IMAGE: `${FRONTEND_URL}/og-image.png`,
  OG_URL: FRONTEND_URL,
};

// Export individual URLs for backward compatibility
export const BASE_URL = API_URL;
export const FRONTEND_BASE_URL = FRONTEND_URL;

// API Config (compatible with axios)
export const API_CONFIG = {
  BASE_URL: API_URL,
  AUTH_URL: `${API_URL}/auth`,
  BOOKING_URL: `${API_URL}/bookings`,
  HOTEL_URL: `${API_URL}/hotels`,
  RESTAURANT_URL: `${API_URL}/restaurants`,
  PROFILE_URL: `${API_URL}/profile`,
  BLOG_URL: `${API_URL}/blog`,
};

export default APP_URLS;
